export default function WavyDivider({ fill = "#FFFDF9", flip = false, className = "" }) {
  return (
    <div
      aria-hidden="true"
      className={`w-full overflow-hidden leading-none ${flip ? "rotate-180" : ""} ${className}`}
    >
      <svg
        viewBox="0 0 1440 70"
        preserveAspectRatio="none"
        className="block h-[36px] w-full sm:h-[64px]"
      >
        <path
          d="M0,42 C120,68 240,12 360,32 C480,52 600,62 720,42 C840,22 960,12 1080,32 C1200,52 1320,62 1440,42 L1440,70 L0,70 Z"
          fill={fill}
        />
      </svg>
    </div>
  );
}
